export const postupConstants = {
	POSTUP_REQUEST: 'POSTUP_REQUEST',
	POSTUP_SUCCESS: 'POSTUP_SUCCESS',
	POSTUP_FAILURE: 'POSTUP_FAILURE',
	GET_POSTUP_REQUEST: 'GET_POSTUP_REQUEST',
	GET_POSTUP_SUCCESS: 'GET_POSTUP_SUCCESS',
	GET_POSTUP_FAILURE: 'GET_POSTUP_FAILURE',
	LIST_POSTUP_REQUEST: 'LIST_POSTUP_REQUEST',
	LIST_POSTUP_SUCCESS: 'LIST_POSTUP_SUCCESS',
	LIST_POSTUP_FAILURE: 'LIST_POSTUP_FAILURE',
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/postupConstants.js